import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "cd-edit-drag" };
const _hoisted_2 = { class: "cd-edit-drag__header" };
const _hoisted_3 = ["src"];
const _hoisted_4 = /*#__PURE__*/ _createElementVNode("hr", null, null, -1);
const _hoisted_5 = /*#__PURE__*/ _createElementVNode("i", { class: "icon icon-plus-12px" }, null, -1);
const _hoisted_6 = /*#__PURE__*/ _createElementVNode("i", { class: "icon icon-question-12px" }, null, -1);
const _hoisted_7 = /*#__PURE__*/ _createElementVNode("i", { class: "icon icon-trash-12px" }, null, -1);
const _hoisted_8 = /*#__PURE__*/ _createElementVNode("i", { class: "icon icon-question-12px" }, null, -1);
const _hoisted_9 = { class: "cd-edit-drag__header" };
const _hoisted_10 = ["src"];
const _hoisted_11 = /*#__PURE__*/ _createElementVNode("hr", null, null, -1);
import { reactive, computed, onMounted } from 'vue';
import i18n from '@/i18n';
import { MatchCityStateOption, } from '../../models';
export default /*#__PURE__*/ _defineComponent({
    __name: 'CustomerDistributionDrag',
    props: {
        store: {},
        seller: {},
        match_city_state: {}
    },
    emits: ['update', 'match-city-state'],
    setup(__props, { emit }) {
        const props = __props;
        const state = reactive({
            id: {
                store: 0,
                seller: 0,
            },
            store: [],
            seller: [],
            matchCityState: {
                value: '',
            },
        });
        onMounted(() => {
            state.store = props.store;
            state.seller = props.seller;
            state.matchCityState.value = props.match_city_state;
        });
        const allowDrop = (_draggingNode, _dropNode, type) => {
            return type !== 'inner';
        };
        const setItem = node => {
            state.id[node.data.type] = node.data.id;
        };
        const handleDrop = (draggingNode, dropNode) => {
            const type = draggingNode.data.type;
            state[type] = dropNode.parent.data;
            emit('update', {
                store: state.store,
                seller: state.seller,
            });
        };
        const addMatch = () => {
            state.matchCityState.value = MatchCityStateOption.ENABLED;
            state.store.push({ column: 'MATCH_CITY_STATE', clause: 'DESC', priority: 4 });
            emit('match-city-state', MatchCityStateOption.ENABLED);
        };
        const customNodeClass = data => {
            return data.class;
        };
        const getMatch = computed(() => {
            return state.matchCityState.value === 'False' ? false : true;
        });
        const removeMatch = () => {
            state.matchCityState.value = MatchCityStateOption.DISABLED;
            state.store = state.store
                .filter(item => item.column !== 'MATCH_CITY_STATE')
                .map((item, index) => ({
                ...item,
                id: index + 1,
                priority: index + 1,
            }));
            emit('match-city-state', MatchCityStateOption.DISABLED);
        };
        const isDragging = (id, priority) => {
            return +id === +priority ? 'dragging' : '';
        };
        const getStores = computed(() => {
            return state.store.map(item => ({
                id: item.priority,
                priority: item.priority,
                column: item.column,
                type: 'store',
                label: i18n.global.t(`customer-distribution.edit.drag.${item.column.toLowerCase()}`),
                class: `cd-edit-drag__store-${item.priority} ${+state.id.store === +item.priority ? 'dragging' : ''}`,
            }));
        });
        const getSeller = computed(() => {
            return state.seller.map(item => ({
                id: item.priority,
                priority: item.priority,
                column: item.column,
                type: 'seller',
                label: i18n.global.t(`customer-distribution.edit.drag.${item.column.toLowerCase()}`),
                class: `${getMatch.value ? 'with-match' : 'not-match'} ${isDragging(state.id.seller, item.priority)} cd-edit-drag__seller-${item.priority} `,
            }));
        });
        return (_ctx, _cache) => {
            const _component_el_tree = _resolveComponent("el-tree");
            const _component_el_popover = _resolveComponent("el-popover");
            const _component_base_card_v2 = _resolveComponent("base-card-v2");
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createVNode(_component_base_card_v2, { class: "cd-edit-drag__card" }, {
                    default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_2, [
                            _createElementVNode("strong", null, _toDisplayString(_ctx.$t('customer-distribution.edit.drag.store')), 1),
                            _createElementVNode("span", null, [
                                _createElementVNode("img", {
                                    class: "icon",
                                    src: require(`@/assets/img/icons/cursor-drag.png`)
                                }, null, 8, _hoisted_3),
                                _createTextVNode(" " + _toDisplayString(_ctx.$t('customer-distribution.edit.drag.order')), 1)
                            ])
                        ]),
                        _hoisted_4,
                        _createVNode(_component_el_tree, {
                            onNodeDragStart: setItem,
                            "allow-drop": allowDrop,
                            data: getStores.value,
                            draggable: "",
                            "default-expand-all": "",
                            "render-after-expand": false,
                            "node-key": "id",
                            class: _normalizeClass(`cd-edit-drag__store`),
                            props: { class: customNodeClass },
                            onNodeDrop: handleDrop
                        }, null, 8, ["data", "props"]),
                        (!getMatch.value)
                            ? (_openBlock(), _createElementBlock("span", {
                                key: 0,
                                class: "cd-edit-drag__match",
                                onClick: addMatch
                            }, [
                                _hoisted_5,
                                _createTextVNode(" " + _toDisplayString(_ctx.$t('customer-distribution.edit.drag.add-match')) + " ", 1),
                                _createVNode(_component_el_popover, {
                                    trigger: "hover",
                                    placement: "right",
                                    width: 260
                                }, {
                                    reference: _withCtx(() => [
                                        _hoisted_6
                                    ]),
                                    default: _withCtx(() => [
                                        _createElementVNode("p", null, _toDisplayString(_ctx.$t('customer-distribution.edit.drag.tooltip-match')), 1)
                                    ]),
                                    _: 1
                                })
                            ]))
                            : (_openBlock(), _createElementBlock("span", {
                                key: 1,
                                class: "cd-edit-drag__match",
                                onClick: removeMatch
                            }, [
                                _hoisted_7,
                                _createTextVNode(" " + _toDisplayString(_ctx.$t('customer-distribution.edit.drag.remove-match')) + " ", 1),
                                _createVNode(_component_el_popover, {
                                    trigger: "hover",
                                    placement: "right",
                                    width: 260
                                }, {
                                    reference: _withCtx(() => [
                                        _hoisted_8
                                    ]),
                                    default: _withCtx(() => [
                                        _createElementVNode("p", null, _toDisplayString(_ctx.$t('customer-distribution.edit.drag.tooltip-match')), 1)
                                    ]),
                                    _: 1
                                })
                            ]))
                    ]),
                    _: 1
                }),
                _createVNode(_component_base_card_v2, { class: "cd-edit-drag__card" }, {
                    default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_9, [
                            _createElementVNode("strong", null, _toDisplayString(_ctx.$t('customer-distribution.edit.drag.seller')), 1),
                            _createElementVNode("span", null, [
                                _createElementVNode("img", {
                                    class: "icon",
                                    src: require(`@/assets/img/icons/cursor-drag.png`)
                                }, null, 8, _hoisted_10),
                                _createTextVNode(" " + _toDisplayString(_ctx.$t('customer-distribution.edit.drag.order')), 1)
                            ])
                        ]),
                        _hoisted_11,
                        _createVNode(_component_el_tree, {
                            onNodeDragStart: setItem,
                            "allow-drop": allowDrop,
                            data: getSeller.value,
                            draggable: "",
                            "default-expand-all": "",
                            "render-after-expand": false,
                            "node-key": "id",
                            class: _normalizeClass(`cd-edit-drag__seller`),
                            props: { class: customNodeClass },
                            onNodeDrop: handleDrop
                        }, null, 8, ["data", "props"])
                    ]),
                    _: 1
                })
            ]));
        };
    }
});
